import * as z from 'zod';

import { priceFrequencyQueryLinkerSchema } from '@/_pages/settings/price-frequencies/shared/schemas/price-frequency-query-linker-schema';
import { productAndServicesQueryLinkerSchema } from '@/_pages/settings/products-and-services-templates/shared/schemas/products-and-services/product-services-query-linker-schema';
import { currencyInput, numericBooleanQuerySchema } from '@/_schemas/generic';

import { clientOptQuerySchema } from './client-opt-schema';

import { deliverableWholesalePriceQuerySchema } from '../wholesale-prices';

export const deliverablesQuerySchema = z.object({
  price_frequency: priceFrequencyQueryLinkerSchema,
  product: productAndServicesQueryLinkerSchema,
  product_id: z.number(),
  price_frequency_id: z.number(),
  sort_order: z.number(),
  sku: z.string(),
  product_name: z
    .string()
    .min(1)
    .refine((val) => val.trim().length > 0, {
      error: 'Product name must not be empty',
    }),

  // number
  quantity: currencyInput.querySchema(),
  // nullable number
  price: currencyInput.querySchema(),

  client_opt: clientOptQuerySchema,
  opted_in: numericBooleanQuerySchema(),
  opted_out: numericBooleanQuerySchema(),
  agreement_id: z.number(),
  id: z.number(),

  deliverable_wholesale_price: z.array(deliverableWholesalePriceQuerySchema).nullable(),

  description: z.string().nullable(),
});

export type DeliverablesQuerySchema = z.infer<typeof deliverablesQuerySchema>;

export function productNameSchema() {
  return z
    .string()
    .min(1)
    .refine((val) => val.trim().length > 0, {
      error: 'Product name must not be empty',
    });
}
